module.exports = __webpack_public_path__ + "media/images/fallback/member_default-d4f580eeec2c1c144dec95023622d8c2.png";